module.exports = __webpack_public_path__ + "static/media/mallvarna.cdf457d3.jpg";